import { FC } from 'react'

import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
    reviewId?: number
    doClose: Function
}
const SubmitReassignHeader: FC<Props> = ({reviewId, doClose}) => {
    return (
    <div className='modal-header'>      
        <h4 className="font-bold">
            { reviewId ? 'Reassign Application Review' : 'Reassign Application'}
        </h4>        
        <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-producttypes-modal-action='close'        
            style={{cursor: 'pointer'}}
            onClick={() => doClose()}
        >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>      
    </div>
    )
}

export {SubmitReassignHeader}
